import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetExpensesStatistics } from "./getExpensesStatistics.request";
import {
  GetExpensesStatisticsBody,
  GetExpensesStatisticsResponse
} from "./getExpensesStatistics.types";

const useExpensesStatistics = (
  requestParams: GetExpensesStatisticsBody,
  options?: QueryOptions<
    GetExpensesStatisticsResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["expenses-statistics", requestParams],
    queryFn: async () => await requestGetExpensesStatistics(requestParams),
    onError: toastServerError,
    ...options
  });

  return {
    statistics: data?.data ?? [],
    totalAmount: data?.totalAmount,
    amountToday: data?.amountToday,
    percentageChangeFromPreviousDay: data?.percentageChangeFromPreviousDay,
    ...rest
  };
};

export default useExpensesStatistics;
